<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-3/3 flex justify-center w-100">
				<ButtonBlack class="mr-2">
					<router-link
						:to="'/admin/listado/' + 'plantillas'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('Plantillas') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack class="mr-2">
					<router-link
						:to="'/admin/listado/' + 'campaigns'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('Campaigns') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack class="mr-2">
					<router-link
						:to="'/admin/listado/' + 'tipos_contrato'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('contrato_tipos') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack class="mr-2">
					<router-link
						:to="'/admin/listado/' + 'base_comercial'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('Base_comercial') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			section: 'configuraciones',
			search: '',
			itemsTitles: ['Id', 'Nombre', 'Organizacion', 'Pais', 'Comercial', 'Tipo']
		}
	}
}
</script>
<style scoped>
.w-24R {
	width: 24rem;
}
.w-100 {
	width: 100%;
}
</style>
